<template>
    <div>
      <section>
        <div class="files-list" v-if="localFiles.length > 0">
          <p class="subtitle">Uploaded files ({{ localFiles.length }})</p>
          <div class="buttons is-right">
            <b-tooltip label="Upload all (not yet synced) files to WFM"
              position="is-left"
              multilined
            >
              <button class="button is-primary"
                @click="uploadAllToWfm"
              >
                Upload all to WFM
              </button>
            </b-tooltip>
          </div>
          <b-table
            :data="localFiles"
            narrowed
            default-sort="['uploaded_date', 'desc']"
          >
            <template slot-scope="props">
              <b-table-column label="File" field="name" sortable>
                <a @click.prevent="getLink(props.row.id)">
                  {{ props.row.name }}
                </a>
              </b-table-column>
              <b-table-column label="Uploaded" field="uploaded_date" sortable>
                {{ formatDate(props.row.uploaded_date) }}
              </b-table-column>
              <b-table-column label="Uploaded by" field="uploaded_by" sortable>
                {{ props.row.uploaded_by }}
              </b-table-column>
              <b-table-column label="Synced to WFM" field="is_wfm_uploaded" sortable>
                <b-icon icon="check" type="is-success" v-if="props.row.is_wfm_uploaded"/>
                <b-icon icon="close" type="is-danger" v-else/>
              </b-table-column>
              <b-table-column label="Size" field="size" sortable>
                {{  formatFileSize(props.row.size) }}
              </b-table-column>
              <b-table-column label="Actions">
                <a href=""
                  @click.prevent="uploadToWfm(props.row.id)"
                  v-if="$auth.check(['admin', 'superadmin'])"
                >
                  <b-tooltip label="Upload to WFM">
                    <b-icon icon="refresh"/>
                  </b-tooltip>
                </a>
                <a href=""
                  @click.prevent="deleteFile(props.row.id)"
                  v-if="$auth.check(['admin', 'superadmin'])"
                >
                  <b-tooltip label="Delete">
                    <b-icon icon="delete"/>
                  </b-tooltip>
                </a>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </section>

      <b-field class="file">
        <b-upload
          multiple
          drag-drop
          v-model="filesToUpload"
          :disabled="editNotAllowed"
          @input="uploadFiles"
        >
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"/>
              </p>
              <p>
                Drop your files here or click to upload
              </p>
            </div>
          </section>
        </b-upload>
      </b-field>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'KycDetailsFiles',
  props: ['kycId', 'files', 'editNotAllowed'],
  data () {
    return {
      filesToUpload: [],
      localFiles: this.files,
      mandateLetterFile: null
    }
  },
  watch: {
    files () {
      this.localFiles = this.files
    }
  },
  methods: {
    uploadFiles () {
      this.filesToUpload.forEach(file => {
        const reader = new FileReader()
        reader.onload = () => {
          this.uploadFile(file.name, file.type, reader.result)
        }
        reader.readAsDataURL(file)
      })
    },
    uploadFile (fileName, fileType, content) {
      this.axios.post(`/kyc/${this.kycId}/upload`, {
        file_name: fileName,
        file_type: fileType,
        content
      })
        .then(response => {
          this.$emit('files-updated', response.data)
          this.$toast.open({
            'message': 'File upload successful',
            'type': 'is-success'
          })
          this.filesToUpload = []
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            'message': error.message,
            'type': 'is-danger'
          })
        })
    },
    getLink (fileId) {
      window.location.replace(
        `${this.axios.defaults.baseURL}/kyc/${this.kycId}/file/${fileId}`
      )
    },
    formatDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    formatFileSize (fileSize) {
      if (fileSize == null) return null

      const units = ['bytes', 'KB', 'MB', 'GB']
      let l = 0
      let n = parseInt(fileSize, 10) || 0
      while (n >= 1024 && ++l) {
        n = n / 1024
      }

      return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l])
    },
    deleteFile (fileId) {
      // check user in backend code as well
      this.axios.delete(`kyc/${this.kycId}/file/${fileId}`)
        .then(response => {
          this.$toast.open({
            'message': response.data.message,
            'type': 'is-success'
          })
          this.$emit('file-deleted', fileId)
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: error.response.data.message || error.message,
            type: 'is-danger'
          })
        })
    },
    uploadToWfm (fileId) {
      this.$store.dispatch('setIsLoading', { isLoading: true })
      this.axios.post(`kyc/${this.kycId}/wfm-upload`, { file_id: fileId })
        .then(response => {
          console.log(response)
          this.$emit('files-updated', response.data)
          this.$toast.open({
            message: 'File uploaded',
            type: 'is-success'
          })
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: error.response.data.message || error.message,
            type: 'is-danger'
          })
        })
        .finally(_ => {
          this.$store.dispatch('setIsLoading', { isLoading: false })
        })
    },
    uploadAllToWfm () {
      this.$store.dispatch('setIsLoading', { isLoading: true })
      this.axios.post(`kyc/${this.kycId}/wfm-upload-all`)
        .then(response => {
          console.log(response)
          this.$emit('files-updated', response.data)
          this.$toast.open({
            message: 'Files uploaded',
            type: 'is-success'
          })
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: error.response.data.message || error.message,
            type: 'is-danger'
          })
        })
        .finally(_ => {
          this.$store.dispatch('setIsLoading', { isLoading: false })
        })
    }
  }
}
</script>

<style scoped>

.upload {
    margin-top: 2em;
    width: 100%;
}

</style>

<style>
.upload-draggable {
    width: 100%;
}
</style>
